import styled, { css } from 'styled-components'

import leaf from './../../../img/heading-leaf.png'
import { Heading } from '../textElements'

export const StyledDecorativeHeading = styled.div``

export const StyledHeading = styled(Heading)`
  margin: 0;
  margin-bottom: 1rem;

  ${props =>
    props.leaves &&
    css`
      display: inline-block;
      position: relative;
      padding: 0 65px;

      ::before,
      ::after {
        content: '';
        position: absolute;
        top: calc(50% - 5px);
        transform: translateY(-50%);

        width: 55px;
        height: 31px;

        background-image: url(${leaf});
        background-size: contain;
        background-repeat: no-repeat;
      }

      ::before {
        left: 0;
      }

      ::after {
        right: 0;
        transform: translateY(-50%) scaleX(-1);
      }
    `}
`

export const Diamond = styled.img`
  display: block;
  width: 100%;
  max-width: 90px;
  height: auto;

  margin: 0 auto 0.25rem;
`
